import React from 'react'

export default ({ name, value, swatchStyle, ...rest }) => (
  <div className="color-presenter" {...rest}>
    <div
      className="color"
      style={{ backgroundColor: value, ...swatchStyle }}
    ></div>
    <h5>{name}</h5>
    <div className="text-muted">{value}</div>
  </div>
)
